import { render, staticRenderFns } from "./CreateDeliveryServiceModal.vue?vue&type=template&id=334f0e5e&scoped=true&"
import script from "./CreateDeliveryServiceModal.vue?vue&type=script&lang=js&"
export * from "./CreateDeliveryServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateDeliveryServiceModal.vue?vue&type=style&index=0&id=334f0e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334f0e5e",
  null
  
)

export default component.exports